// export const api_raiz= "http://localhost:8000/";

// Produccion
export const socket="https://ws.skyangel.com.mx:8443/mensajeria-1.0/";
// export const api_raiz= "https://one.skynavieros.com:8080/skyone_qa/";
export const api_raiz= "https://one.skynavieros.com:8080/skyone/";
export const api_ia = "https://apibot.skynavieros.com/";
